import sample_1 from './idealProtect.jpg';

export const idealProtect = {
    sample_1,
};
